import React from "react"
import "./footer.sass"
import { injectIntl, Link } from "gatsby-plugin-intl"
import { DownloadBtns } from "./download-btn"
import ZhLogo from "../images/logo_footer.png"
import EnLogo from "../images/logo-en_.png"
import { getEmail, window } from "../utils"

const Footer = ({ intl }) => {
  const origin = window.location.origin
  return (
    <footer className="footer">
      <div className="container">
        <div className="columns">
          <div className="column is-one-quarter">
            <h3>
              <a href={intl.locale === "zh" ? "https://fantuanreview.com/" : "https://fantuanreview.com/en"}>
                {intl.formatMessage({ id: "footer.title" })}
              </a>
            </h3>
          </div>
          <div className="column is-half-desktop">
            <div className="columns is-mobile">
              {/* <div className="column is-one-third"> */}
              {/*  <ul className="foot-link"> */}
              {/*    <li> */}
              {/*      <a href="/">{intl.formatMessage({ id: "footer.aboutus" })}</a> */}
              {/*    </li> */}
              {/*    <li> */}
              {/*      <a href="/">{intl.formatMessage({ id: "footer.news" })}</a> */}
              {/*    </li> */}
              {/*    <li> */}
              {/*      <a href="/">{intl.formatMessage({ id: "footer.careers" })}</a> */}
              {/*    </li> */}
              {/*  </ul> */}
              {/* </div> */}
              <div className="column is-one-third">
                <ul className="foot-link">
                  {/* <li> */}
                  {/*  <a href="#">{intl.formatMessage({ id: "footer.contact" })}</a> */}
                  {/* </li> */}
                  <li>
                    <Link to="/faq/">{intl.formatMessage({ id: "footer.faq" })}</Link>
                  </li>
                  <li>
                    <a href={`${origin}/agreement.html`}>{intl.formatMessage({ id: "footer.policy" })}</a>
                  </li>
                  <li>
                    <a href={`${origin}/termsofservice.html`}>{intl.formatMessage({ id: "footer.term" })}</a>
                  </li>
                </ul>
              </div>
              <div className="column is-one-third">
                <ul className="foot-link">
                  <li>
                    <Link to="/partner/">{intl.formatMessage({ id: "footer.partner" })}</Link>
                  </li>
                  <li>
                    <Link to="/driver/">{intl.formatMessage({ id: "footer.driver" })}</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="column is-one-quarter">
            <div className="columns lastcol">
              <div className="column">
                <p className="words">{intl.formatMessage({ id: "footer.advice" })}</p>
                <p>
                  <a href={`mailto:${getEmail('advice')}`}>{getEmail('advice')}</a>
                </p>
              </div>
              <div className="column">
                <p className="words">{intl.formatMessage({ id: "footer.adserving" })}</p>
                <p>
                  <a href={`mailto:${getEmail('adserving')}`}>{getEmail('adserving')}</a>
                </p>
              </div>
              <div className="column">
                <p className="words">{intl.formatMessage({ id: "footer.cooperation" })}</p>
                <p>
                  <a href={`mailto:${getEmail('cooperation')}`}>{getEmail('cooperation')}</a>
                </p>
              </div>
              <div className="column">
                <DownloadBtns invert />
              </div>
            </div>
          </div>
        </div>

        <div className="bottom">
          <div className="columns">
            <div className="column company-logo">
              <img src={intl.locale === "zh" ? ZhLogo : EnLogo} alt="Fantuan Delivery" />
            </div>
            <div className="column company-name">Copyright © {new Date().getFullYear()} Fantuan </div>
            <div className="column">
              <div className="social">
                <a
                  href="https://www.facebook.com/Van-Fantuan-582755635428346/?eid=ARBjICJYGD2h7qQ0JDddDn4-C-OovGA7gvTch8cfn8_xpsB7eTtm3zt-UrEEqo9BuNWfizjyOrprYDw-"
                  className="fb"
                >
                  Facebook
                </a>
                <a href="https://www.youtube.com/channel/UCz8NWT_9fiQ1Q9fweNnPESw" className="yt">
                  YouToBe
                </a>
                <a href="https://www.linkedin.com/company/17924108" className="li">
                  LinkedIn
                </a>
                <a
                  href={
                    intl.locale === "fr"
                      ? "https://instagram.com/ft_montreal?igshid=YmMyMTA2M2Y="
                      : "https://instagram.com/fantuanofficial?igshid=9d7nbxt2tx7z"
                  }
                  className="is"
                >
                  instagram
                </a>
                <a href="https://weibo.com/fantuandelivery" className="wb">
                  weibo
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default injectIntl(Footer)
